import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/razvan/my-work/YonTech.Fat.Samples/angular.realworld.io/angular.realworld.io/fat/docs-src/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "concepts"
    }}>{`Concepts`}</h1>
    <h2 {...{
      "id": "fattest"
    }}>{`FatTest`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`using Yontech.Fat;

public class HomePageTests : FatTest
{
    HomePage homePage { get; set; }

    public override void BeforeEachTestCase()
    {
        WebBrowser.Navigate("https://example.com/home");
    }

    public void Test_should_have_welcome_message()
    {
        homePage.WelcomeMessage.ShouldContainText("Welcome");
    }

    public void Test_header_should_contain_login_button()
    {
        // ... 
    }
}
`}</code></pre>
    <p>{`To write test cases you should:`}</p>
    <ul>
      <li parentName="ul">{`Create a class which inherits from `}<inlineCode parentName="li">{`FatTest`}</inlineCode></li>
      <li parentName="ul">{`Create public methods which start with `}<inlineCode parentName="li">{`Test`}</inlineCode>{` keyword. Each one of this methods will be considered a test case`}</li>
      <li parentName="ul">{`Override lifecycle events to execute actions before or after each test case`}<ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`BeforeEachTestCase`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`BeforeAllTestCases`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`AfterEachTestCase`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`AfterAllTestCases`}</inlineCode></li>
        </ul></li>
      <li parentName="ul">{`Add properties for `}<a parentName="li" {...{
          "href": "#fatpage"
        }}>{`FatPage`}</a>{`s, `}<a parentName="li" {...{
          "href": "#fatpagesection"
        }}>{`FatPageSection`}</a>{`s, `}<a parentName="li" {...{
          "href": "#fatflow"
        }}>{`FatFlow`}</a>{`s that will be used in test cases`}<blockquote parentName="li">
          <p parentName="blockquote">{`FatFramework will inject those properties for you at runtime so you don't need to care about constructing them.`}</p>
        </blockquote></li>
    </ul>
    <h2 {...{
      "id": "fatpage"
    }}>{`FatPage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`using Yontech.Fat;
using Yontech.Fat.WebControls;

public class HomePage : FatPage
{
    public ITextControl WelcomeMessage => _.Text("#welcome-message-id");

    public IButtonControl LoginButton => _.Button(".some-class .login-btn");
}
`}</code></pre>
    <p>{`The role of `}<inlineCode parentName="p">{`FatPage`}</inlineCode>{` is to have all elements of a page grouped in a single place so that they can be reused in multiple TestCases.
Each page element will have defined:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Type`}</strong>{`. It can be Text, TextBox, Button, Dropdown, Link, ... or custom components`}</li>
      <li parentName="ul"><strong parentName="li">{`Name`}</strong>{`. We recommend to include the type of the component inside the name. eg. instead of `}<em parentName="li">{`Login`}</em>{` use `}<em parentName="li">{`LoginButton`}</em></li>
      <li parentName="ul"><strong parentName="li">{`CSS selector`}</strong>{` used to identify the component on the page `}</li>
    </ul>
    <p>{`These are being linked together by the builtin `}<a parentName="p" {...{
        "href": "#controlfinder-aka-_"
      }}>{`ControlFinder`}</a>{` which is available using the `}<inlineCode parentName="p">{`_`}</inlineCode>{` (underscore) sign. `}</p>
    <h2 {...{
      "id": "fatpagesection"
    }}>{`FatPageSection`}</h2>
    <p>{`It is very similar to `}<a parentName="p" {...{
        "href": "#fatpage"
      }}>{`FatPage`}</a>{`, the difference between these two is semantically. The difference is that instead of `}<inlineCode parentName="p">{`FatPage`}</inlineCode>{` you should use `}<inlineCode parentName="p">{`FatPageSection`}</inlineCode>{`.`}</p>
    <p>{`Use `}<inlineCode parentName="p">{`FatPage`}</inlineCode>{` when elements that you want to define are inside a page (which is usually linked to a URL).`}</p>
    <p>{`Use `}<inlineCode parentName="p">{`FatPageSection`}</inlineCode>{` when you want to define elements that not linked to a URL, for example Header, Footer, Menu, Modals, Confirmation popups.`}</p>
    <h2 {...{
      "id": "fatcustomcomponent"
    }}>{`FatCustomComponent`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`using Yontech.Fat;
using Yontech.Fat.WebControls;

public class ArticleItem : FatCustomComponent
{
    public ILinkControl UserNameLink => _.Link(".author");
    public ITextControl PublishedDateText => _.Text("span.date");
    public ITextControl TitleText => _.Text(".preview-link h1");
}

// This is how ArticleItem custom component can be used
public class ArticlesPage : FatPage
{
    public ArticleItem SelectedArticle => _.Custom<ArticleItem>(".article-item.selected");

    public ArticleItem ArticleAtPosition(int index)
    {
        var articles = _.CustomList<ArticleItem>(".article-item");
        return articles.ElementAt(index);
    }
}

// Now let's see it in action in a test
public class ArticlePageTests : FatTest
{
    ArticlesPage articlesPage { get; set; }

    public void Test_first_article_should_has_valid_title()
    {
        articlesPage.ArticleAtPosition(0).TitleText.ShouldContainText("Have you been to Romania?");
    }

    public void Test_click_on_username_for_selected_article()
    {
        articlesPage.SelectedArticle.UserNameLink.Click();
    }
}
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`Custom Components is a powerful concept in FatFramework. We recommend creating one for each Component that developer did in their source code. This way, every time they change one component you will know what needs to be adjusted in Fat project.`}</p>
    </blockquote>
    <h2 {...{
      "id": "fatflow"
    }}>{`FatFlow`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`using Yontech.Fat;

public class SignInFlows : FatFlow
{
    SignInPage signInPage { get; set; }

    public void Login(string username, string password)
    {
        signInPage.EmailTextInput.ClearAndTypeKeys(username);
        signInPage.PasswordTextInput.ClearAndTypeKeys(password);

        signInPage.SignInButton.Click();
    }
}

// This is an example of how it can be used
public class ProfilePageTests: FatTest 
{
    SingInFlows signInFlows { get; set; }

    public void Test_something()
    {
        signInFlows.Login("john.snow", "hold-the-door");

        // ...
    }

    // or it can be used in lifecycle events like
    public override void BeforeEachTestCase()
    {
        WebBrowser.Navigate("https://example.com/login");
        signInFlows.Login("john.snow", "hold-the-door");
    }
}

`}</code></pre>
    <h2 {...{
      "id": "controlfinder-aka-_"
    }}>{`ControlFinder (aka _)`}</h2>
    <h3 {...{
      "id": "the-api-to-search-for-a-single-element"
    }}>{`The API to search for a single element`}</h3>
    <ul>
      <li parentName="ul">{`Text`}</li>
      <li parentName="ul">{`TextBox`}</li>
      <li parentName="ul">{`Button`}</li>
      <li parentName="ul">{`Link`}</li>
      <li parentName="ul">{`RadioButton`}</li>
      <li parentName="ul">{`Checkbox`}</li>
      <li parentName="ul">{`Dropdown`}</li>
      <li parentName="ul">{`Custom`}</li>
    </ul>
    <h3 {...{
      "id": "the-api-to-search-list-of-elements"
    }}>{`The API to search list of elements`}</h3>
    <ul>
      <li parentName="ul">{`TextList`}</li>
      <li parentName="ul">{`TextBoxList`}</li>
      <li parentName="ul">{`ButtonList`}</li>
      <li parentName="ul">{`LinkList`}</li>
      <li parentName="ul">{`CustomList`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      